module.exports = __webpack_public_path__ + "img/cca-mysql-level-1.4aa16df2.png";